import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { FriendSummaryData } from 'src/model/Social';
import { GetRazorSiteUrl, ImageLocation } from 'src/utils/URLUtils';
import styles from './FriendsItem.module.scss';

interface FriendsItemProps {
    friend: FriendSummaryData;
}

export const FriendsItem = ({ friend }: FriendsItemProps) => {
    const { open } = useIFrameModal();
    const { userInfo } = useUser();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();


    const handleClick = () => {
        if (friend.SubscriptionId === '-1') {
            navigate('/progress');
        } else if (friend.SubscriptionId !== '-1') {
            open(GetRazorSiteUrl(`profile/friend`, userInfo?.Token, `&id=${friend.Handle}`), friend.DisplayName!);
        }
    };

    return (
        <div onClick={handleClick}
            className={styles.friendsItem}>
            <img className={styles.avatar}
                src={friend.Avatar ?? ImageLocation('Profile-3.png')}
                onError={(e) => {
                    e.currentTarget.src = ImageLocation('Profile-3.png');
                }}
                alt={friend.DisplayName ?? 'User'} />
            <span className={styles.name}>{friend.DisplayName}</span>
            {friend.DisplayName !== 'More' && <div dir={i18n.dir()} className={styles.progressTime}>
                <span className={styles.progressTimeValue}>{friend.CurrentWeekProgress}</span>
                <span className={styles.progressTimeUnit}>{t('min')}</span>
            </div>}

        </div>
    );
};